<template>
  <div class="modal-mask">
    <div class="modal" role="dialog" v-click-outside="close">
      <div class="modal__body">
        <slot name="body"></slot>
      </div>
      <a
        v-if="canClose"
        href="javascript:void(0)"
        class="modal__close"
        @click="close"
      >
        <svg-icon icon="close" />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Modal',

  emits: ['close'],

  props: {
    canClose: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const close = (): void => {
      if (props.canClose) {
        emit('close');
      }
    };

    return {
      close,
    };
  },
});
</script>

<style lang="scss" scoped>
@use 'sass:map';

.modal-mask {
  position: fixed;
  z-index: map.get($z-index, 'modal');
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($black, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal {
  position: relative;
  width: 80%;
  max-width: 600px;
  padding: 40px;
  background-color: $white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba($black, 0.33);
  transition: all 0.3s ease;

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
</style>
